module.exports = __webpack_public_path__ + "static/media/gallery10.305f4f06.png";